module.exports = __webpack_public_path__ + "static/img/dili.96b55c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/dili.png
// module id = XE1G
// module chunks = 0